var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5C6.19891 10.5 6.38968 10.579 6.53033 10.7197C6.67098 10.8603 6.75 11.0511 6.75 11.25V12.75C6.75 14.1424 7.30312 15.4777 8.28769 16.4623C9.27225 17.4469 10.6076 18 12 18C13.3924 18 14.7277 17.4469 15.7123 16.4623C16.6969 15.4777 17.25 14.1424 17.25 12.75V11.25C17.25 11.0511 17.329 10.8603 17.4697 10.7197C17.6103 10.579 17.8011 10.5 18 10.5C18.1989 10.5 18.3897 10.579 18.5303 10.7197C18.671 10.8603 18.75 11.0511 18.75 11.25V12.75C18.75 14.4104 18.138 16.0126 17.0312 17.2503C15.9243 18.4879 14.4001 19.2743 12.75 19.459V21.75H15.75C15.9489 21.75 16.1397 21.829 16.2803 21.9697C16.421 22.1103 16.5 22.3011 16.5 22.5C16.5 22.6989 16.421 22.8897 16.2803 23.0303C16.1397 23.171 15.9489 23.25 15.75 23.25H8.25C8.05109 23.25 7.86032 23.171 7.71967 23.0303C7.57902 22.8897 7.5 22.6989 7.5 22.5C7.5 22.3011 7.57902 22.1103 7.71967 21.9697C7.86032 21.829 8.05109 21.75 8.25 21.75H11.25V19.459C9.59988 19.2743 8.07571 18.4879 6.96884 17.2503C5.86196 16.0126 5.25002 14.4104 5.25 12.75V11.25C5.25 11.0511 5.32902 10.8603 5.46967 10.7197C5.61032 10.579 5.80109 10.5 6 10.5Z",
    fill: "url(#paint0_linear_8517_19341)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 4.5C8.25 3.50544 8.64509 2.55161 9.34835 1.84835C10.0516 1.14509 11.0054 0.75 12 0.75C12.9946 0.75 13.9484 1.14509 14.6517 1.84835C15.3549 2.55161 15.75 3.50544 15.75 4.5V12.75C15.75 13.7446 15.3549 14.6984 14.6517 15.4017C13.9484 16.1049 12.9946 16.5 12 16.5C11.0054 16.5 10.0516 16.1049 9.34835 15.4017C8.64509 14.6984 8.25 13.7446 8.25 12.75V4.5Z",
    fill: "url(#paint1_linear_8517_19341)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8517_19341",
    x1: 25.5,
    y1: 16.875,
    x2: 12.7708,
    y2: 3.39702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B90E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8517_19341",
    x1: 19.5,
    y1: 8.625,
    x2: 7.27264,
    y2: 2.80245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72BBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B90E2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroBlue);
export default __webpack_public_path__ + "static/media/micro-blue.2e0dd5145b70d63cfb027982f9f8b2d7.svg";
export { ForwardRef as ReactComponent };